package nl.astraeus.wiki.messages

import nl.astraeus.wiki.domain.WikiListDto

class WikiListEntryMessage() : Message(
  MessageType.WIKI_LIST_ENTRY_MESSAGE,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(
    messageId: String,
    wiki: WikiListDto
  ) : this() {
    setHeader(MessageHeader.MESSAGE_ID, messageId)
    setBody(wiki.tokenize())
  }

}
